import React, { createContext, useContext, useMemo } from 'react';
import { transMailContactModel2ContactItem } from '@web-common/utils/contact_util';
import { getContactItemKey } from '@web-common/components/util/contact';
const SelectorContext = createContext(null);
export const useSelectorContext = () => {
    const context = useContext(SelectorContext);
    if (!context) {
        throw new Error('useSelectorContext must be used within SelectorProvider');
    }
    return context;
};
export const SelectorProvider = ({ items, type, selectedEmails, children }) => {
    const value = useMemo(() => {
        const selectedItemsMap = new Map();
        const contactItemList = [];
        items === null || items === void 0 ? void 0 : items.forEach(item => {
            const contactItem = transMailContactModel2ContactItem(item);
            const contactKey = getContactItemKey(contactItem);
            selectedItemsMap.set(contactKey, contactItem);
            contactItemList.push(contactItem);
        });
        const selectedEmailsSet = new Set(selectedEmails);
        return {
            selectedItems: selectedItemsMap,
            contactItemList,
            type,
            selectedEmails,
            selectedEmailsSet,
        };
    }, [items, type, selectedEmails]);
    return React.createElement(SelectorContext.Provider, { value: value }, children);
};
